import { Project } from "../../../models/project.model";
import { ProjectsActions } from "./projects.actions";
import { ProjectsState } from "./projects.state";

export const initialState = {
  projects: [],
  activeProjectIndex: undefined,
};

export function ProjectsReducer(state: ProjectsState = initialState, action) {
  let projects;

  switch (action.type) {
    case ProjectsActions.V2_SET_PROJECTS:
      return {
        ...state,
        projects: [...action.payload.projects],
      };

    case ProjectsActions.V2_ADD_PROJECT:
      projects = [
        ...state.projects,
        {
          ...action.payload.project,
        },
      ];

      return {
        ...state,
        projects: projects,
        activeProjectIndex: projects.length - 1,
      };

    case ProjectsActions.V2_ADD_OR_UPDATE_PROJECT:
      projects = [...state.projects];

      if (
        projects.filter((project) => project.id === action.payload.project.id)
          .length
      ) {
        projects = projects.map((project) => {
          if (project.id === action.payload.project.id) {
            return action.payload.project;
          }
          return project;
        });
      } else {
        projects.push(action.payload.project);
      }

      return {
        ...state,
        projects: projects,
      };

    case ProjectsActions.V2_SET_ACTIVE_PROJECT:
      return {
        ...state,
        activeProjectIndex: state.projects.indexOf(action.payload.project),
      };

    case ProjectsActions.V2_UPDATE_ACTIVE_PROJECT:
      projects = [...state.projects];
      projects[state.activeProjectIndex] = {
        ...action.payload.project,
        dirty: action.payload.project.dirty,
      };

      return {
        ...state,
        projects: projects,
      };

    case ProjectsActions.V2_SAVE_PROJECT_STEP:
      projects = [...state.projects];

      let project = projects[state.activeProjectIndex];
      project.dirty = true;
      project[action.payload.step] = {
        ...projects[state.activeProjectIndex][action.payload.step],
        completed: action.payload.valid,
        fields: action.payload.fields,
      };

      return {
        ...state,
        projects: [...state.projects],
      };

    case ProjectsActions.SET_ADDRESSES:
      projects = [...state.projects];
      projects[
        state.activeProjectIndex
      ].projectFormAreaCreate.fields.building.addresses =
        action.payload.addresses;

      return {
        ...state,
        projects: projects,
      };

    case ProjectsActions.V2_DELETE_ALL:
      return { ...initialState };

    case ProjectsActions.V2_ARCHIVE_PROJECT:
      return {
        ...state,
        projects: [
          ...state.projects.map((project) => {
            if (project.id === action.payload.project.id) {
              project.archived = true;
            }
            return project;
          }),
        ],
      };

    case ProjectsActions.V2_RESTORE_PROJECT:
      return {
        ...state,
        projects: [
          ...state.projects.map((project) => {
            if (project.id === action.payload.project.id) {
              project.archived = false;
              project.dirty = false;
            }
            return project;
          }),
        ],
      };

    case ProjectsActions.V2_SET_SYNC_ACTION:
      return {
        ...state,
        projects: [
          ...state.projects.map((project) => {
            if (project.id === action.payload.project.id) {
              project.syncAction = action.payload.action;
              if (action.payload.action) {
                project.dirty = true;
              }
            }
            return project;
          }),
        ],
      };

    case ProjectsActions.V2_PROJECT_LAST_SYNCED_AT:
      return {
        ...state,
        projects: [
          ...state.projects.map((project) => {
            if (project.id === action.payload.project.id) {
              project.lastSyncedAt = action.payload.lastSyncedAt;
            }
            return project;
          }),
        ],
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/states/v2/projects/projects.reducer.ts